module.exports = __webpack_public_path__ + "img/tracteurrouge_off.cea7fc24.gif";